import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { LanguageProvider } from './context/LanguageContext';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

function mountApp() {
  root.render(
    <React.StrictMode>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </React.StrictMode>
  );
}

const qrMatch = window.location.pathname.match(/^\/r\/([A-Za-z0-9_-]+)$/);
if (qrMatch) {
  const shortcode = qrMatch[1];
  document.getElementById('root').innerHTML =
    '<div style="display:flex;align-items:center;justify-content:center;height:100vh;font-family:sans-serif;color:#ccc;background:#0a0a0a"><p>Weiterleitung…</p></div>';
  fetch(`/api/qr?shortcode=${encodeURIComponent(shortcode)}`)
    .then(r => (r.ok ? r.json() : Promise.reject()))
    .then(data => {
      if (data && data.destination_url && data.destination_url.startsWith('http')) {
        window.location.replace(data.destination_url);
      } else {
        mountApp();
      }
    })
    .catch(() => mountApp());
} else {
  mountApp();
}

reportWebVitals();
